export default "__VITE_ASSET__B9ej01IN__"